import React from "react";
import { Table } from "@redriver/cinnamon";
import EditSignatory from "features/Companies/Customers/Signatories/Actions/EditSignatory";
import RejectSignatory from "features/Companies/Customers/Signatories/Actions/RejectSignatory";
import ArchiveSignatory from "features/Companies/Customers/Signatories/Actions/ArchiveSignatory";
import UnarchiveSignatory from "features/Companies/Customers/Signatories/Actions/UnarchiveSignatory";
import { CustomerSignatoryState } from "features/../../../shared/constants/enums";

const CustomerSignatoryActions = ({
  state,
  isArchived,
  signatoryId,
  clientId,
  forceUpdate,
}) => {
  const authorised = state === CustomerSignatoryState.Authorised;
  const rejected = state === CustomerSignatoryState.Rejected;
  const archived = isArchived;
  return (
    <Table.Menu>
      <EditSignatory
        isAuthorised={authorised}
        signatoryId={signatoryId}
        clientId={clientId}
        forceUpdate={forceUpdate}
      />
      {authorised && !archived && (
        <ArchiveSignatory
          signatoryId={signatoryId}
          clientId={clientId}
          forceUpdate={forceUpdate}
        />
      )}
      {!rejected && !archived && (
        <RejectSignatory
          signatoryId={signatoryId}
          clientId={clientId}
          forceUpdate={forceUpdate}
        />
      )}
      {archived && (
        <UnarchiveSignatory
          signatoryId={signatoryId}
          clientId={clientId}
          forceUpdate={forceUpdate}
        />
      )}
    </Table.Menu>
  );
};
export default CustomerSignatoryActions;
